export type PaymentType =
  | 'cashDocuments'
  | 'creditDocuments'
  | 'receiptFeeDocuments';

export type IDocument = {
  id: number;
  businessName: string;
  businessIdentifier: string;
  amount: number;
  netAmount?: number;
  type?: string;
  subType?: string;
  financialNodeId: number;
  financialNodeInternalKey: string;
  creditNotesAmount?: number;
  amountToPay?: number;
};

export type IDocumentWithDisplay = IDocument & {
  displayAmount: number;
};

export type IDocumentStore = {
  cashDocuments: IDocument[];
  creditDocuments: IDocument[];
  receiptFeeDocuments: IDocument[];
};

export type IBankAccount = {
  id: number;
  bankName: string;
  accountNumber: string;
};

export type IPayment = {
  id: number;
  businessName: string;
  businessIdentifier: string;
  amount: number;
  financialNodeId: number;
  financialNodeInternalKey: string;
};

export type IPaymentRequest = {
  businessName: string;
  amount: number;
  documents: IDocument[];
};

export const getDisplayAmount = (doc: IDocument): number => {
  if (doc.type !== 'receipt-fee') return doc.amountToPay ?? doc.amount;
  return doc.netAmount ?? doc.amount;
};
